import Vue from 'vue'
import Router from 'vue-router'
import Agent from '@/models/Agent';
import moment from 'moment'
import Cart from '@/models/Cart';

import NotFound from './views/NotFound.vue'
import Portal from './views/Portal.vue'
import Home from './views/Home.vue'
import Categories from './views/Categories.vue'
import CategoryItems from './views/CategoryItems.vue'
import Activity from './views/Activity.vue'
import PointToPoint from './views/PointToPoint.vue'
import Package from './views/Package.vue'
import Product from './views/Product.vue'
import GiftCertificate from './views/GiftCertificate.vue'
import PortalSettings from '@/models/PortalSettings';

import CartView from './views/Cart.vue'
import Checkout from './views/Checkout.vue'
import Confirmation from './views/Confirmation.vue'

import Availability from './views/Availability.vue'
import Ticket from './views/Ticket.vue'

import AgentHome from './views/agent/Home.vue'
import AgentLogin from './views/agent/Login.vue'
import AgentProfile from './views/agent/Profile.vue'
import AgentInfo from './views/agent/Info.vue'
import AgentResetPassword from './views/agent/ResetPassword.vue'
import AgentEmailSent from './views/agent/EmailSent.vue'
import AgentSetPassword from './views/agent/SetPassword.vue'

import FindMyBooking from './views/FindMyBooking.vue'
import MyBooking from './views/MyBooking.vue'

const categoryItems = {
  component: CategoryItems,
  meta: { breadcrumbs: ['categories'] }
}

const PAPItem = {
  meta: { breadcrumbs: ['categories', 'category'] }
};

const HomeCrumb = {
  route: { name: 'home' },
  label: 'home.label'
};

const AgentHomeCrumb = {
  route: { name: 'agent' },
  label: 'agent.label.home'
};

// If the agent is not logged in, make them.
const AgentGuard = {
  beforeEnter(to, from, next) {
    let agent = Agent.active();

    if (agent && !agent.autoLogin) {
      next();
    } else {
      next({ name: 'agent-login', params: to.params, query: to.query });
    }
  }
}

const HeaderGuard = {
  beforeEnter(to, from, next){
    console.log(to);
  }
}

const dateItem = {
  props: (route) => ({ id: parseInt(route.params.id), date: route.query.date, editing: route.query.editing })
}

Vue.use(Router)

var router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [{
    path: '/:portal',
    component: Portal,
    children: [{
      path: '',
      name: 'home',
      component: Home,
      children: [{
        path: 'activities/',
        name: 'category-activity',
        component: Categories,
        //...HeaderGuard,
        props: { type: 'activity' }
      }, {
        path: 'packages/',
        name: 'category-package',
        component: Categories,
        //...HeaderGuard,
        props: { type: 'package' }
      }, {
        path: 'products/',
        name: 'category-product',
        component: Categories,
        //...HeaderGuard,
        props: { type: 'product' }
      }, {
        path: 'gift-certificate/',
        name: 'giftcert',
        //...HeaderGuard,
        component: GiftCertificate,
        props: (route) => ({editing: route.query.editing})
      }]
    }, {
      path: 'activities/category/:category/',
      name: 'activity-items',
      ...categoryItems,
      props: (route) => ({ type: 'activity', category: parseInt(route.params.category), date: route.query.date })
    }, {
      path: 'packages/category/:category/',
      name: 'package-items',
      ...categoryItems,
      props: (route) => ({ type: 'package', category: parseInt(route.params.category), date: route.query.date })
    }, {
      path: 'products/category/:category/',
      name: 'product-items',
      ...categoryItems,
      props: (route) => ({ type: 'product', category: parseInt(route.params.category), date: route.query.date })
    }, {
      path: 'activity/:id/',
      name: 'activity',
      component: Activity,
      ...PAPItem,
      ...dateItem
    }, {
      path: 'activity/:id/linked-products/',
      name: 'activity-linked-products',
      component: Activity,
      ...PAPItem,
      props: (route) => ({ id: parseInt(route.params.id), date: route.params.date, showLinkedProducts: true })
    }, {
      path: 'activity/:id/linked-activities/',
      name: 'activity-linked-activities',
      component: Activity,
      ...PAPItem,
      props: (route) => ({ id: parseInt(route.params.id), date: route.params.date, showLinkedActivities: true })
    }, {
      path: 'p2p/',
      name: 'p2p',
      component: PointToPoint,
      props: (route) => ({
        date: route.query.date,
        returnDate: route.query.returnDate,
        fromCityId: parseInt(route.query.from) || undefined,
        toCityId: parseInt(route.query.to) || undefined,
        pickupId: parseInt(route.query.pickup) || undefined,
        dropoffId: parseInt(route.query.dropoff) || undefined,
        roundTrip: !!(parseInt(route.query.roundTrip) || 1),  // !! trick to get proper Boolean in Javascript
      })
    }, {
      path: 'p2p/linked-products/',
      name: 'p2p-linked-products',
      component: PointToPoint,
      props: (route) => ({
        showLinkedProducts: true,
        date: route.query.date,
        returnDate: route.query.returnDate,
        fromCityId: parseInt(route.query.from) || undefined,
        toCityId: parseInt(route.query.to) || undefined,
        pickupId: parseInt(route.query.pickup) || undefined,
        dropoffId: parseInt(route.query.dropoff) || undefined,
        roundTrip: !!(parseInt(route.query.roundTrip) || 1),  // !! trick to get proper Boolean in Javascript
        selectedRouteId: parseInt(route.query.selectedRouteId) || undefined,
        selectedReturnRouteId: parseInt(route.query.selectedReturnRouteId) || undefined,
      })
    },
    {
      path: 'package/:id/',
      name: 'package',
      component: Package,
      ...PAPItem,
      ...dateItem,
    }, {
      path: 'product/:id/',
      name: 'product',
      component: Product,
      ...PAPItem,
      props: (route) => ({ id: parseInt(route.params.id) })
    }, {
      path: 'activities/category/:category/availability/',
      name: 'availability',
      component: Availability,
      ...PAPItem,
      props: (route) => ({ categoryId: parseInt(route.params.category) })
    }, {
      path: 'cart/',
      name: 'cart',
      component: CartView,
      meta: {
        breadcrumbs: [HomeCrumb]
      }
    }, {
      path: 'checkout/',
      name: 'checkout',
      component: Checkout,
      meta: {
        breadcrumbs: [HomeCrumb]
      }
    }, {
      path: 'confirmation/:bookingId/:be',
      name: 'confirmation',
      component: Confirmation,
      props: (route) => ({ bookingId: parseInt(route.params.bookingId), be: route.params.be })
    }, {
      path: 'ticket/:bookingId/:be',
      name: 'ticket',
      component: Ticket,
      props: (route) => ({ bookingId: parseInt(route.params.bookingId), be: route.params.be })
    }, {
      path: 'agent/',
      name: 'agent',
      component: AgentHome,
      ...AgentGuard,
      meta: {
        breadcrumbs: [HomeCrumb]
      }
    }, {
      path: 'agent/login/',
      name: 'agent-login',
      component: AgentLogin,
      // If the agent is already logged in, take them home.
      beforeEnter(to, from, next) {
        let agent = Agent.active();
        if (!agent || agent.autoLogin) {
          next();
        } else {
          next({ name: 'agent', params: to.params, query: to.query });
        }
      }
    }, {
      path: 'agent/profile/',
      name: 'agent-profile',
      component: AgentProfile,
      meta: { breadcrumbs: [HomeCrumb, AgentHomeCrumb] },
      ...AgentGuard
    }, {
      path: 'agent/info/',
      name: 'agent-info',
      component: AgentInfo,
    }, {
      path: 'agent/reset-password/',
      name: 'agent-reset-password',
      component: AgentResetPassword,
    }, {
      path: 'agent/email-sent/',
      name: 'agent-email-sent',
      component: AgentEmailSent,
    }, {
      path: 'agent/set-password/',
      name: 'agent-set-password',
      component: AgentSetPassword,
    }, {
      path: 'my-booking/find/',
      name: 'find-mybooking',
      component: FindMyBooking,
    }, {
      path: 'my-booking/',
      name: 'mybooking',
      component: MyBooking,
    }, {
      path: '404/',
      name: 'not-found',
      component: NotFound
    }, {
      path: '*',
      redirect: { name: 'not-found' }
    }]
  // }, {
  //   path: '*',
  //   redirect: to => {
  //     console.log('catchall', to);
  //     return {
  //       name: 'not-found',
  //       params: { portal: 'default'}
  //     };
  //   }
  }]
});

export default router;
